import styled from 'styled-components';

export const Logo = styled.img`
  height: ${({ theme, height }) => `${theme.getValue(height)}`};
  width: ${({ theme, width }) => `${theme.getValue(width)}`};
  object-fit: contain;
  position: absolute;
  bottom: ${({ theme }) => theme.getValue(22)};
  right: ${({ theme }) => theme.getValue(38)};
  z-index: 1;

  &.center-bottom {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
  }
`;
